import React, { useRef, useState, useEffect } from 'react';
import Dither from './Dither';
import BlurText from './BlurText';

const Hero = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const scrollToPricing = () => {
    const pricingSection = document.querySelector('#pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="hero" id="home" ref={sectionRef}>
      <div className="dither-container">
        <Dither
          waveColor={[0.9098039215686274, 1, 0.050980392156862744]}
          disableAnimation={!isVisible}
          enableMouseInteraction={isVisible}
          mouseRadius={0.1}
          colorNum={16}
          pixelSize={1}
          waveAmplitude={0.35}
          waveFrequency={3.5}
          waveSpeed={0.01}
        />
      </div>

      <div className="container">
        <div className="hero-content">
          <p className="hero-label">ALWAYS CONNECTED</p>
          <h1 className="hero-title">
            <BlurText
              text="Your Path to Unlimited Access"
              delay={62}
              direction="top"
            />
          </h1>
          <p className="hero-subtitle">
            <BlurText
              text="Empowering you to navigate the web freely, securely, and without limits, on every path you choose."
              delay={62}
              direction="bottom"
            />
          </p>

          <div className="hero-buttons">
            <button className="cta-button" onClick={scrollToPricing}>View Pricing</button>
          </div>

          <div className="hero-stats-left">
            <div className="rating">
              <div className="rating-score">5.0</div>
              <div className="rating-details">
                <div className="stars">★★★★★</div>
                <p>from 200+ reviews</p>
              </div>
            </div>
          </div>

          <div className="hero-stats-right">
            <div className="stat-item">
              <h3>50K+</h3>
              <p>USERS<br/>WORLDWIDE</p>
            </div>
            <div className="stat-item">
              <h3>99.9 %</h3>
              <p>UPTIME<br/>GUARANTEE</p>
            </div>
          </div>
        </div>

        <div className="hero-badges">
          <div className="hero-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E8FF00" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            <span>HTTP/S & SOCKS5</span>
          </div>
          <div className="hero-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E8FF00" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
            <span>195+ Locations</span>
          </div>
          <div className="hero-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E8FF00" strokeWidth="2">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
            </svg>
            <span>Ultra-Low Latency</span>
          </div>
          <div className="hero-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E8FF00" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <span>Zero Logs</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
